import type { InputHTMLAttributes, Ref, SelectHTMLAttributes } from 'react';
import { cx } from './cx';

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'md' | 'lg' | 'touch';
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
}

export function Input({ size = 'md', invalid, className, ...rest }: InputProps) {
  return (
    <input
      className={cx('eb-input', className)}
      data-size={size}
      aria-invalid={invalid ? true : undefined}
      {...rest}
    />
  );
}

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  size?: 'md' | 'lg' | 'touch';
  invalid?: boolean;
  ref?: Ref<HTMLSelectElement>;
}

export function Select({ size = 'md', invalid, className, children, ...rest }: SelectProps) {
  return (
    <select
      className={cx('eb-select', className)}
      data-size={size}
      aria-invalid={invalid ? true : undefined}
      {...rest}
    >
      {children}
    </select>
  );
}
